import { render, staticRenderFns } from "./leagueCourserDetailList.vue?vue&type=template&id=66163a0b&scoped=true"
import script from "./leagueCourserDetailList.vue?vue&type=script&lang=ts"
export * from "./leagueCourserDetailList.vue?vue&type=script&lang=ts"
import style0 from "./leagueCourserDetailList.vue?vue&type=style&index=0&id=66163a0b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66163a0b",
  null
  
)

export default component.exports